import { render, staticRenderFns } from "./CustomEducation.vue?vue&type=template&id=0229e600&scoped=true"
import script from "./CustomEducation.vue?vue&type=script&lang=js"
export * from "./CustomEducation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0229e600",
  null
  
)

export default component.exports